import i18n from "../../i18n";

export function ObjectiveType() {
    return Object.freeze({
        admin: { key: "admin", value: i18n.t("objective.admin") },
        admin_route: { key: "admin_route", value: i18n.t('objective.admin-route') },
    });
}